var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2850_13995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V28H28V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18.6666C23.5773 18.6666 25.6667 16.5773 25.6667 13.9999C25.6667 11.4226 23.5773 9.33325 21 9.33325",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 9.33325C4.42259 9.33325 2.33325 11.4226 2.33325 13.9999C2.33325 16.5773 4.42259 18.6666 6.99992 18.6666",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18.6666V18.3749V16.9166V13.9999V9.33325C7 5.46726 10.134 2.33325 14 2.33325C17.866 2.33325 21 5.46726 21 9.33325V18.6666C21 22.5326 17.866 25.6666 14 25.6666",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2850_13995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSvgrepoCom1);
export default __webpack_public_path__ + "static/media/contact-svgrepo-com 1.d0c35f691e8193c1ea249b47174ceed9.svg";
export { ForwardRef as ReactComponent };